import Swiper, { Autoplay } from 'swiper';

window.addEventListener('load', () => {
    document.querySelectorAll('.swiper.ad-banners').forEach((el) => {
        new Swiper(el, {
            modules: [Autoplay],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loop: true,
        });
    });
});
